import React from "react";
import {HeaderCard} from "../Base/HeaderCard";
import {NavigationHeader} from "../Navigation/NavigationHeader";
import {useTranslation} from "react-i18next";
import {useParams, useNavigate} from "react-router-dom";
import {Grid, Box} from "@mui/material";
import classes from '../../styling/components/UserDashboard.module.css'
import {CampaignAnalyticsSummary} from "../../model/CampaignAnalyticsSummary";
import {CampaignOverviewCard} from "../Analytics/Base/CampaignOverviewCard";
import {FeatureCard} from "./FeatureCard";
import EmailIcon from '@mui/icons-material/Email';
import SettingsIcon from '@mui/icons-material/Settings';
import GridViewIcon from '@mui/icons-material/GridView';
import HelpIcon from '@mui/icons-material/Help';

interface Props {
    campaigns: CampaignAnalyticsSummary[];
}

export const UserDashboardOverview: React.FC<Props> = ({ campaigns }) => {
    const {t} = useTranslation()
    const {customerId} = useParams()
    const navigate = useNavigate()

    const navigation = [
        {url: "", label: t("userDashboard.title") || "Dashboard"}
    ]


    // Select the single running campaign with the most total mails
    const selectedCampaign = React.useMemo(() => {
        const runningCampaigns = campaigns.filter(c => c.status === "Running");
        
        if (runningCampaigns.length === 0) {
            return null;
        }
        
        // Find running campaign with most total mails
        return runningCampaigns.reduce((prev, current) => 
            (current.total > prev.total) ? current : prev
        );
    }, [campaigns]);

    return (
        <>
            <NavigationHeader path={navigation}/>
            <HeaderCard
                headline={<>{t('userDashboard.welcomeHeader')}</>}
                body={<>{t('userDashboard.welcomeText')}</>}
            />

            {selectedCampaign && (
                <Box className={classes.sectionSpacingAfterHeader}>
                    <CampaignOverviewCard 
                        campaign={selectedCampaign} 
                        label={t("userDashboard.featuredCampaign")}
                    />
                </Box>
            )}

            <Box className={classes.sectionSpacing}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6}>
                        <FeatureCard
                            title={t("userDashboard.analyticsCard.title")}
                            description={t("userDashboard.analyticsCard.description")}
                            icon={GridViewIcon}
                            onClick={() => navigate(`/customers/${customerId}/analytics`)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <FeatureCard
                            title={t("userDashboard.templatesCard.title")}
                            description={t("userDashboard.templatesCard.description")}
                            icon={EmailIcon}
                            onClick={() => navigate(`/customers/${customerId}/templates`)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <FeatureCard
                            title={t("userDashboard.settingsCard.title")}
                            description={t("userDashboard.settingsCard.description")}
                            icon={SettingsIcon}
                            onClick={() => navigate(`/customers/${customerId}/settings`)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <FeatureCard
                            title={t("userDashboard.helpCard.title")}
                            description={t("userDashboard.helpCard.description")}
                            icon={HelpIcon}
                            onClick={() => window.location.href = 'mailto:support@look2x.de'}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

